import { oppTick } from './opp5';
import { comTick, comOnEnact } from './com';
import { since } from './version';
import { landDeal, kraftMonths, admOnEnact, admTick } from './adm';
import {fiscalTick} from './fiscal';
import {versusTick,versusOnGovern,humanVotes,humanPartners,versusOnEnact,ltwVersus,isVersus} from './versus';
import {versusOnLawVote} from './versus';
import {RESS} from '../content/ressorts';
import {DEMO} from '../content/lawtables';
import {GROUPS,WEIGHT} from '../content/axes';
import {MONTHS,NEED} from '../content/consts';
import {EVENTS} from '../content/events';
import {ISSUES,TPL} from '../content/issues';
import {OUTLETS} from '../content/parties';
import {DI,on} from '../content/settings';
import {BRV,STATES} from '../content/states';
import {zgEnact,inForce} from './v2';
import {polarEnact,polarTick} from './polar';
import {traceTick} from './trace';
import {blocker,budgetTick,debtLimit,etatGr,etatIss,etatMonthly,structSaldo} from './budget';
import {fileSuit,suitTick} from './court';
import {crisisTick} from './crises';
import {decisionTick} from './decisions';
import {econTick,inflPen} from './economy';
import {coalSeats,lawsLeg} from './election';
import {initInd,updInd} from './indicators';
import {issueLifecycle} from './lifecycle';
import {lobbyReact,lobbyTick} from './lobbies';
import {lteTick,needFor,pushLT} from './longterm';
import {fillerNews,mediaOnLaw,opposition,press} from './media';
import {defaultRess,formCabinet,lingerTick,ministerEvents,ressBonus} from './ministers';
import {wingReact,wingTick} from './party';
import {addBestand,applyRepeal} from './repeal';
import {rnd,shuffle} from './rng';
import {PA,PN,satWith,score} from './rules';
import {S,log} from './state';
import {openReview,legStartSnap} from './review';
import {zgTick} from './zeitgeist';
import {sideMonth,onEnact,onDone} from './effects';
import {runHearing,defectors} from './parliament';
import {clamp,dateYear,de} from './util';
import {issuesNow} from './axes';

export function startGovern(){
  const cont=S.leg>0&&Object.keys(S.issues).length>0;
  S.phase='govern';
  if(!cont){S.m=0;issuesNow().forEach((i:any)=>S.issues[i.id]={sev:i.sev,prev:i.sev,cut:0,law:null,on:i.at===0})}
  else{const keep=['kraft','done','repealed'],gone=S.laws.filter((L)=>!keep.includes(L.stage));gone.forEach((L)=>{if(L.iss&&S.issues[L.iss])S.issues[L.iss].law=null});
    S.laws=S.laws.filter((L)=>keep.includes(L.stage));S.press=0;S.oppBill=null;S.lastVote=null;if(since(5)){S.oppMove=null;S.ua=null;if(S.com)S.com.focus=null}
    if(gone.length)log(`Diskontinuität: ${gone.length} unfertige ${gone.length===1?'Vorhaben verfällt':'Vorhaben verfallen'} mit der neuen Legislatur.`)}
  S.m0=S.m;S.legYear=S.elYear;
  if(!S.agree){S.agree={...S.you};S.fin='YOU'}
  S.minority=coalSeats()<NEED;
  if(!RESS.every((r:any)=>S.ress[r.id]==='YOU'||S.partners.includes(S.ress[r.id])))S.ress=defaultRess();
  formCabinet();versusOnGovern();S.tab='lage';S.budget=null;S.bview=false;S.scandal=null;S.pickFor=null;S.linger=null;S.scandalsLeg=0;
  const sats=S.partners.map((p:any)=>satWith(p,S.agree)+ressBonus(p));
  S.coal=sats.length?clamp(45+30*(sats.reduce((a:any,b:any)=>a+b,0)/sats.length),0,100):100;
  const ys=satWith('YOU',S.agree);S.basis=(cont?S.basis*.5:0)-Math.max(0,.85-ys)*20;
  S.prev=null;if(!cont)moods(true);S.prev=snap();
  if(!S.ind||!Object.keys(S.ind).length)initInd();S.ind0={...S.ind};addBestand();legStartSnap();
  if(S.partners.length)log(`Koalitionsvertrag unterzeichnet: ${['YOU',...S.partners].map(PA).join(', ')}. Die Regierung ist im Amt.`,'good');
  else log(S.minority?`${S.name} regiert allein.`:`${S.name} regiert mit absoluter Mehrheit allein.`,'good');
  log(`Das Kabinett ist vereidigt: ${RESS.length} Ressorts, davon ${RESS.filter((r:any)=>S.ress[r.id]==='YOU').length} bei ${S.name}.`);
  if(S.minority)log(`Minderheitsregierung mit ${coalSeats()} von 630 Sitzen. Für jedes Gesetz braucht ihr Stimmen aus der Opposition.`);
  if(ys<.7)log('Teile eurer Basis halten den Koalitionsvertrag für einen Verrat am Wahlprogramm.','bad');
  traceTick(true);
}
export function moods(instant?:any){
  const act=issuesNow().filter((i:any)=>S.issues[i.id].on||S.issues[i.id].solved!=null);
  for(const g in GROUPS){
    let n=0,d=0;act.forEach((i:any)=>{const w=i.imp[g]||0;n+=S.issues[i.id].sev*w;d+=w});
    const pen=d?n/d*.3:0;
    const def=Math.min(30,Math.max(0,debtLimit()-S.saldo)*.45);
    const t=clamp(62+S.bonus[g]-pen-def+(S.gr-.6)*5-(S.al-6.2)*4-inflPen(g),0,100);
    S.mood[g]=instant?t:S.mood[g]+(t-S.mood[g])*.3;
  }
}
export const approval:any=()=>Object.keys(WEIGHT).reduce((s:any,k:any)=>s+S.mood[k]*WEIGHT[k],0);
export const poll:any=()=>clamp(S.elec+(approval()-45)*.5+S.basis+(S.press||0)*.3,4,60);
export function snap(){return{poll:poll(),appr:approval(),saldo:S.saldo,debt:S.debt,gr:S.gr,al:S.al,mood:{...S.mood},lob:{...(S.lob||{})}}}
export const activeLaws:any=()=>S.laws.filter((L)=>!['kraft','done','failed','blocked','ready'].includes(L.stage)||L.stage==='ready').filter((L)=>!['kraft','done'].includes(L.stage));

export function btVote(pos?:any,L?:any){let yes=0;const by:any={};
  for(const id of S.res.inP){const s=score(id,pos);const c=id==='YOU'||S.partners.includes(id);
    const y=id==='YOU'?true:c?s>=.35:s>=(S.minority?(id==='HO'?.72:.66):(id==='HO'?.75:.72));by[id]={y,s};if(y)yes+=S.res.seats[id]}
  // Zwei-Spieler-Modus: Die Partei des Mitspielers stimmt so, wie er es angekündigt hat.
  for(const h of humanVotes(L)){if(by[h.id]&&by[h.id].y!==h.y){by[h.id].y=h.y;yes+=(h.y?1:-1)*S.res.seats[h.id]}}
  // Abweichler in Regierungsfraktionen, wenn das Gesetz schlecht zum Programm passt (nicht bei Spielerparteien)
  const hum=humanVotes(L).map((h)=>h.id);
  for(const id of ['YOU',...S.partners]){const b=by[id];if(!b||!b.y||hum.includes(id))continue;const d=defectors(S.res.seats[id]||0,b.s,id==='YOU'?.55:.5);if(d){b.dev=d;yes-=d}}
  return{yes,by}}
export function brVote(pos?:any,second?:any,deal=0){let y=0;deal+=landDeal();
  for(const id in STATES){const g=S.gov[id],c=g==='YOU'||S.partners.includes(g),s=score(g,pos);
    if(g==='YOU'||(c?s>=.35:s>=(second?.45:.55)-deal))y+=STATES[id].v}
  return y/BRV}
export function stateMood(id?:any){const st=STATES[id];let n=0,d=0;
  for(const g in WEIGHT){let w=WEIGHT[g];if(g==='rent')w*=1+st.age;if(g==='jung')w*=1+st.urb;if(g==='unt')w*=1+st.ind;n+=S.mood[g]*w;d+=w}
  return n/d+((S.stOff||{})[id]||0)}
export function toast(t:string,k:string=''){S.toast={t,k,id:rnd()}}
export function landtagswahl(){
  if(!S.ltwQ.length)S.ltwQ=shuffle(Object.keys(STATES));
  const id=S.ltwQ.shift()!,st=STATES[id],old=S.gov[id];S.ltwNext=S.m+3;
  const md=stateMood(id)-approval();
  if(isVersus()){ // Mehrspieler: alle Spielerparteien und die stärkste Konkurrenz im Land treten an, die stärkste Partei regiert
    const r=ltwVersus(id,old,md);S.gov[id]=r.gov;
    const nowYou=r.gov==='YOU',txt=`Landtagswahl in ${st.n}: ${r.list.map((x)=>`${PN(x.id)} ${de(x.s)} %`).join(', ')}. `+(r.gov===old?`${PA(old)} regiert weiter.`:`Die Landesregierung geht an ${PA(r.gov)}.`);
    log(txt,nowYou&&old!=='YOU'?'good':old==='YOU'&&!nowYou?'bad':'');
    press(OUTLETS[0].n,`Landtagswahl in ${st.n}: ${r.gov===old?`${PA(old)} verteidigt die Regierung`:`Machtwechsel, ${PA(r.gov)} gewinnt`}`,nowYou?.6:old==='YOU'?-.6:0);
    toast(txt,nowYou?'good':old==='YOU'?'bad':'');
    return;
  }
  const share=clamp(poll()+md*.8+(rnd()*4-2),3,60);
  const win=share>=(old==='YOU'?27:30);
  S.gov[id]=win?'YOU':(old==='YOU'?st.alt:old);
  const txt=`Landtagswahl in ${st.n}: ${S.name} holt ${de(share)} %. `+(win?(old==='YOU'?'Ihr regiert weiter.':'Ihr übernehmt die Landesregierung.'):(old==='YOU'?`Die Landesregierung geht an ${PA(S.gov[id])}.`:`${PA(S.gov[id])} regiert weiter.`));
  log(txt,win?'good':old==='YOU'?'bad':'');
  press(OUTLETS[0].n,`Landtagswahl in ${st.n}: ${win?'Erfolg':'Dämpfer'} für ${S.name}`,win?.6:-.6);
  toast(txt,win?'good':old==='YOU'?'bad':'');
}
export function cabinetCheck(fx?:any){return S.partners.map((p:any)=>{const s=score(p,fx.pos);let st='ok';
  if(S.fin===p&&((fx.b<-6&&s<.5)||(fx.b<-2&&S.saldo+fx.b<debtLimit()&&s<.6)))st='fin';else if(s<.35)st='block';else if(s<.45)st='grumble';return{p,s,st}})}

export function introduce(L?:any){
  // Abgestimmte Entwürfe kann der Mitspieler als Partner im Kabinett nicht mehr blockieren.
  const r=cabinetCheck(L.fx).filter((x:any)=>!(L.agreed&&humanPartners().includes(x.p)));
  const bad=r.find((x:any)=>x.st==='block'||x.st==='fin');
  if(bad){L.stage='blocked';L.why=bad.st==='fin'?`Der Finanzminister (${PA(bad.p)}) verweigert die Zustimmung, der Entwurf ist ihm zu teuer oder reißt die Schuldenbremse.`:`${PN(bad.p)} blockiert den Entwurf im Kabinett.`;
    S.coal=clamp(S.coal-3,0,100);log(`Kabinett: ${L.t} gestoppt. ${L.why}`,'bad');press(OUTLETS[0].n,`Koalitionsstreit: „${L.t}“ im Kabinett gestoppt`,-1);return}
  r.filter((x:any)=>x.st==='grumble').forEach((x:any)=>{S.coal-=4;log(`${PA(x.p)} trägt „${L.t}“ nur widerwillig mit.`)});
  L.stage='bt';L.left=3;log(`Kabinett beschließt „${L.t}“. Erste Lesung im Bundestag.`);
  runHearing(L,L.br?brVote(L.fx.pos,false):null);
}
export function enact(L?:any){
  if(L.rep){applyRepeal(L);lobbyReact(L.fx,.7);wingReact(L.fx,.7);L.stage='done';L.leg=S.leg;return}
  L.stage='kraft';L.phase=0;L.leg=S.leg;if(since(4))L.vn=kraftMonths(L.rid);onEnact(L);admOnEnact(L);comOnEnact(L);zgEnact(L);if(!inForce(L.t,L))polarEnact(L);
  const ys=score('YOU',L.fx.pos);
  if(ys<.45){S.basis-=1.5;log(`Eure Stammwähler sehen „${L.t}“ als Bruch mit dem Programm.`,'bad')} else if(ys>=.75)S.basis=Math.min(3,S.basis+.5);
  S.partners.forEach((p:any)=>{if(score(p,L.fx.pos)>=.75)S.coal=clamp(S.coal+3,0,100)});
  log(`„${L.t}“ tritt in Kraft. Die Wirkung entfaltet sich über ${L.vn&&L.vn!==6?`${L.vn} Monate`:'sechs Monate'}.`,'good');
  mediaOnLaw(L);
  if(L.fx.lim){S.limBonus=(S.limBonus||0)+L.fx.lim;log(`Die Schuldenbremse ist reformiert: ${de(L.fx.lim,0)} Mrd € mehr Spielraum für Investitionen.`,'good')}
  pushLT(L);versusOnEnact(L);
  lobbyReact(L.fx);wingReact(L.fx);fileSuit(L);
  {const T=TPL(L.iss,L.tpl||0),dm=DEMO[T.t];if(dm&&on('demo'))S.demoCut=clamp((S.demoCut||0)+dm(L.p||{}),-.5,.8)}
}

export function tick(){
  if(S.phase!=='govern'||blocker())return false;
  let att=false;S.prev=snap();S.m++;const nn=S.news.length;S.press*=.85;
  // Probleme
  issuesNow().forEach((i:any)=>{const st=S.issues[i.id];st.prev=st.sev;
    if(!st.on&&i.at!=null&&st.solved==null&&S.m>=i.at){st.on=true;att=true;log(`Neues Problem auf der Agenda: ${i.n}.`,'bad');toast(`Neues Problem: ${i.n}`,'bad')}
    if(st.on)st.sev=clamp(st.sev+i.rate*(1-st.cut)+(rnd()*.6-.3)-etatIss(i.id),0,100)});
  // Gesetzgebung
  for(const L of S.laws){
    if(L.stage==='draft'){if(--L.left<=0){L.stage='ready';att=true;log(`Referentenentwurf fertig: „${L.t}“. Bereit fürs Kabinett.`)}}
    else if(L.stage==='bt'){if(--L.left<=0){const v=btVote(L.fx.pos,L);L.vote=v;versusOnLawVote(L,v,v.yes>=needFor(L.fx));
      S.lastVote={id:L.id+'-'+S.m,m:S.m,t:L.t,yes:v.yes,ok:v.yes>=needFor(L.fx),by:Object.fromEntries(Object.entries<any>(v.by).map(([k,x])=>[k,x.y]))};
      toast(`Bundestag: „${L.t}“ ${v.yes>=needFor(L.fx)?'angenommen':'abgelehnt'} (${v.yes} Ja)`,v.yes>=needFor(L.fx)?'good':'bad');
      S.partners.forEach((p:any)=>{if(!v.by[p].y&&!L.fx.gg){S.coal=clamp(S.coal-10,0,100);log(`${PN(p)} stimmt gegen das eigene Regierungsgesetz.`,'bad')}});
      const devs=Object.keys(v.by).reduce((a:number,k:string)=>a+(v.by[k].dev||0),0);if(devs)log(`Abweichler: ${devs} Abgeordnete der Regierungsfraktionen stimmen gegen „${L.t}“.`,'bad');
      if(v.yes>=needFor(L.fx)){log(`Bundestag: „${L.t}“ angenommen mit ${v.yes} von 630 Stimmen.`,'good');if(L.br){L.stage='br';L.left=1}else enact(L)}
      else{L.stage='failed';if(S.minority)S.basis-=.5;L.why=`Im Bundestag gescheitert: nur ${v.yes} Ja-Stimmen, nötig sind ${needFor(L.fx)}.${S.minority?' Überarbeite den Entwurf so, dass genug Oppositionsparteien zustimmen.':''}`;log(`Bundestag: „${L.t}“ abgelehnt (${v.yes} Ja).`,'bad');press(OUTLETS[0].n,`Niederlage im Bundestag: Regierung scheitert mit „${L.t}“`,-1)}
      att=true}}
    else if(L.stage==='br'){if(--L.left<=0){const r=brVote(L.fx.pos,false);
      if(r>(L.fx.gg?2/3:.5)){log(`Bundesrat stimmt „${L.t}“ zu.`,'good');enact(L)}else{L.stage='vm';L.left=2;log(`Bundesrat lehnt „${L.t}“ ab. Vermittlungsausschuss wird angerufen.`,'bad')}att=true}}
    else if(L.stage==='vm'){if(--L.left<=0){const r=brVote(L.fx.pos,true,L.deal?.12:0);
      if(r>(L.fx.gg?2/3:.5)){log(`Kompromiss im Vermittlungsausschuss: „${L.t}“ kommt durch.`,'good');enact(L)}else{L.stage='failed';L.why='Auch nach dem Vermittlungsausschuss fehlt im Bundesrat die Mehrheit.';log(`„${L.t}“ endgültig im Bundesrat gescheitert.`,'bad')}att=true}}
    else if(L.stage==='kraft'){const f=L.fx,st=S.issues[L.iss!],n=since(4)&&L.vn?L.vn:6;
      for(const g in (f.g||{}))S.bonus[g]+=f.g![g]/n;
      S.lawB+=(f.b||0)/n;S.lawGr+=(f.gr||0)/n;S.lawAl+=(f.al||0)/n;st.sev=Math.max(0,st.sev-(f.sev||0)/n*(L.q||1));sideMonth(L);
      if((L.phase=(L.phase||0)+1)>=n){L.stage='done';if(since(5))L.doneM=S.m;st.cut=Math.max(st.cut,Math.min(.9,(f.cut||0)*(L.q||1)));st.law=null;onDone(L)}}
  }
  // Ereignis
  if(on('events')&&rnd()<[.07,.1,.13][DI()]){const ev=EVENTS[Math.floor(rnd()*EVENTS.length)];
    if(!ev.iss||Object.keys(ev.iss).every((k:any)=>S.issues[k].on)){
      if(ev.crisis)S.crisisM=S.m;if(ev.gr)S.shockGr+=ev.gr;if(ev.b)S.shockB+=ev.b;if(ev.coal)S.coal=clamp(S.coal+ev.coal,0,100);
      for(const g in (ev.g||{}))S.bonus[g]+=ev.g[g];for(const k in (ev.iss||{}))S.issues[k].sev=clamp(S.issues[k].sev+ev.iss[k],0,100);
      log(`${ev.t}: ${ev.s}`,'bad');press(OUTLETS[ev.coal?3:0].n,`${ev.t}: ${ev.s}`,ev.b>0||ev.gr>0?.5:-.5);S.event=ev;att=true}}
  if(opposition())att=true;if(oppTick())att=true;versusTick();
  if(S.m>=S.ltwNext){landtagswahl();att=true}
  econTick();
  if(lobbyTick())att=true;
  if(wingTick())att=true;
  if(suitTick())att=true;
  if(crisisTick())att=true;
  else if(decisionTick())att=true;
  if(S.saldo<debtLimit()-8&&!S.notYear&&rnd()<.08){S.shockGr-=.3;S.basis-=.5;log('Die EU-Kommission leitet ein Defizitverfahren gegen Deutschland ein.','bad');press(OUTLETS[1].n,'Defizitverfahren: Brüssel rügt die deutsche Haushaltspolitik',-1.5);att=true}
  if(ministerEvents())att=true;
  if(lingerTick())att=true;
  if(budgetTick())att=true;
  if(fiscalTick())att=true;
  if(issueLifecycle())att=true;
  if(lteTick())att=true;
  // Wirtschaft
  for(const g in S.bonus)S.bonus[g]*=.97;
  etatMonthly();
  admTick();
  comTick();
  const sv=(k:any)=>S.issues[k].on?S.issues[k].sev:0;
  const grT=1.5+S.lawGr+S.shockGr+etatGr()-(on('infl')?(S.zins-2.1)*.15:0)-(sv('infra')*.006+sv('energie')*.005+sv('fach')*.005);
  S.gr+=(grT-S.gr)*.25;S.shockGr*=.88;S.lawGr*=.995;
  S.al=clamp(S.al+((6.2-(S.gr-.6)*.9+S.lawAl)-S.al)*.12,2,15);
  S.saldo=structSaldo();S.shockB*=.92;
  S.debt+=-S.saldo/12;
  S.coal=clamp(S.coal+(65-S.coal)*.03,0,100);
  moods(false);
  polarTick();
  updInd();zgTick();traceTick();
  if(S.news.length===nn)fillerNews();
  if(S.end==='misstrauen'){S.phase='end';att=true}
  else if(S.partners.length&&S.coal<15){S.end='coal';S.phase='end';att=true}
  else if(S.m-S.m0>=MONTHS){openReview(false);att=true}
  if(S.phase==='end')S.career.push({a:S.legYear,b:dateYear(S.m),s0:S.elec,s1:S.end==='election'?S.final:null,laws:lawsLeg(),how:S.end||''});
  return att;
}

